<template>
  <div class="memberActive">
    <div class="from_content">
      <div class="step2">
        <h2>激活内容</h2>
        <van-radio-group v-model="radio" @change="changeRadio" direction="horizontal">
          <van-radio name="2" checked-color="#FF7F41">会员激活</van-radio>
          <van-radio name="1" checked-color="#FF7F41">课程/电子书激活</van-radio>
        </van-radio-group>
        <!-- 激活会员 -->
        <div v-if="radio === '2'">
          <van-field
            @input="getphoneValue"
            v-model.trim="tmallCard"
            type="input"
            placeholder="请输入防伪码激活"
          />
          <h3>领取会员说明</h3>
          <h4>每个防伪码仅可以开通一次会员，是开通会员的唯一凭证，请谨慎保管及时开通</h4>
        </div>
        <!-- 激活课程 -->
        <div  v-if="radio === '1'">
          <van-field
            @input="getphoneValue"
            v-model.trim="tmallCard"
            type="input"
            placeholder="请输入防伪码激活"
          />
          <h3>领取课程说明</h3>
          <h4>1.免费领课仅限购买启航教育书课包新产品</h4>
          <h4>2.刮开图书封面右下角“扫码领课”的涂层并输入进行校验</h4>
          <h4>3.每个校验码仅可领取一次课程，是领课的唯一凭证，请谨慎保管及时领课</h4>
          <h4>4.该活动最终解释权归启航龙图教育科技有限公司所有</h4>

          <h3>领取电子书说明</h3>
          <h4>每个防伪码仅可领取一次电子书，是开通电子书的唯一凭证，请谨慎保管及时开通</h4>
        </div>
      </div>
    </div>
    <div class="fixedbottom">
      <div class="tmallBtn" :class="{ active: selected !== -1 }" @click="onClickTmall">
        点击激活
      </div>
    </div>
    <Loading ref="load" />
    <MemberSuccess @changeShow="changeShow" :onShow="onShow" />
    <CourseSuccess :styleTemplate="styleTemplate" @courseChangeShow="courseChangeShow" :subCatalogId="subCatalogId" :productType="productType" :courseShow="courseShow" />
  </div>
</template>

<script>
import Loading from '@/components/loading/loading.vue';
import { reqcheckCode } from '@/api/personal/courseTmall';
import { reqCourseDetail } from '@/api/courseDetail/index';
import MemberSuccess from './memberSuccess.vue';
import CourseSuccess from './courseSuccess.vue';

export default {
  components: {
    Loading,
    MemberSuccess,
    CourseSuccess,
  },
  data() {
    return {
      radio: '2',
      tmallCard: '',
      selected: -1,
      onShow: false,
      courseShow: false,
      subCatalogId: '', // 开课记录id
      productType: '', //
      styleTemplate: '', // 电子书模版类型
    };
  },

  computed: {},
  mounted() {},

  methods: {
    changeRadio() {
      this.tmallCard = '';
      this.selected = -1;
    },
    getphoneValue() {
      if (this.tmallCard) {
        this.selected = 0;
      } else {
        this.selected = -1;
      }
    },
    async onClickTmall() {
      if (this.selected === -1) {
        this.$toast('请输入防伪码激活');
        return;
      }
      if (!this.tmallCard) {
        this.$toast('请输入防伪码激活');
      } else {
        this.$refs.load.show = true;
        const res = await reqcheckCode({
          code: this.tmallCard,
          type: this.radio,
        });
        if (res.msg == '请求成功' && res.description != '该防伪码为正版') {
          // 验证成功
          // this.$toast('领取成功，即将跳转成功页')
          if (this.radio == '2') {
            this.onShow = true;
          } else {
            this.subCatalogId = res.data?.openCourseId;
            this.productType = res.data?.productType;
            if (this.productType == 3) {
              const { data } = await reqCourseDetail(res.data?.productId);
              const { productSkuRespVOList } = data;
              this.styleTemplate = productSkuRespVOList[0].productSkuEbookStyleTemplate;
            }
            this.courseShow = true;
          }
          // this.$refs.load.show = false;
          // return;
        } else if (res.msg == '请求成功' && res.description == '该防伪码为正版') {
          this.$toast(res.description);
        } else if (res.code == '19106') {
          // 防伪码已经使用
          this.$toast(res.msg);
        } else if (res.code == '19107') {
          // 您已有该课程
          this.$toast('您已有该课程，请在app中查看');
        } else {
          this.$toast(res.msg);
        }
        this.$refs.load.show = false;
      }
    },
    // 会员
    changeShow() {
      this.onShow = false;
    },
    // 课程
    courseChangeShow() {
      this.courseShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.memberActive {
  .from_content {
    width: 670px;
    margin: 0 auto;
    padding: 64px 60px 120px 60px;
    background: #fff;
    border-radius: 24px;
    box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.06);
    ::v-deep {
      .van-cell {
        padding: 0;
        .van-field__body {
          .van-field__control {
            width: 275px;
            height: 60px;
            padding-left: 16px;
            color: #333;
            font-weight: 400;
            font-size: 14px;
            background: #f8f9fb;
            border-radius: 10px;
          }
          input::-webkit-input-placeholder {
            color: #a5a5a5;
          }
        }
      }
      .van-radio-group--horizontal{
          justify-content: space-around;
          margin-bottom: 20px;
          .van-radio__label{
            font-size: 16px;
          }
      }

    }
  }
  .step2 {
    h2 {
      margin-bottom:48px;
      color: #333;
      font-weight: 500;
      font-size: 32px;
    }
    h3 {
      margin-top: 40px;
      color: #fc7e36;
      font-weight: 500;
      font-size: 28px;
      line-height: 40px;
      margin-block: 28px;
    }
    h4 {
      color: #999;
      font-weight: 400;
      font-size: 24px;
      line-height: 34px;
    }
  }
   .fixedbottom {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    width: 750px;
    height: 167px;
    padding-top: 32px;
    background: #fff;
    border-radius: 22px 22px 2px 2px;
    .tmallBtn {
      width: 678px;
      height: 80px;
      margin: 0 auto;
      color: #fff;
      font-size: 32px;
      line-height: 80px;
      text-align: center;
      background: #ff7f41;
      border-radius: 49px;
      opacity: 0.5;
    }
  }

  .tmallBtn.active {
    opacity: 1;
  }
}
</style>
